import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileStore } from '@lib/store';
import { cn, FormatUtils, PaletteUtils, PermissionUtils } from '@shared/utils';
import { EditDetailsModal } from '../widgets';
import { Button, Icon, Text } from '@shared/widgets';
import SettingIcon from '@assets/icons/setting.svg';
import ChevronIcon from '@assets/icons/chevron.svg';

interface UserCorporateOptionsProps {
  className?: string;
}

export const UserCorporateOptions = (props: UserCorporateOptionsProps) => {
  const profileStore = useUnit($profileStore.store);

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [showEditDetailsModal, setShowEditDetailsModal] = useState<boolean>(false);

  const { t } = useTranslation('profile');

  return (
    <div
      className={cn(
        'border-b-gray-200 mb-2 cursor-pointer border-b last:mb-0 last:border-b-0',
        PaletteUtils.isVcfcPalette && 'border-b-gray-black/40',
        props.className,
      )}
    >
      <div
        className={cn(
          'mb-2 flex min-h-12 cursor-pointer items-center py-4 transition-colors duration-200',
          'hover:bg-smoky-white dark:hover:bg-transport-black',
        )}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div
          className={cn(
            'mr-4 flex flex-none items-center justify-center text-slate transition-colors duration-200 dark:text-white',
            PaletteUtils.isInsigniaPalette && [isOpen && 'text-primary dark:text-primary'],
          )}
        >
          <Icon icon={<SettingIcon />} color='inherit' />
        </div>
        <Text className='flex-auto'>{t('corporateOptions.title')}</Text>
        <div className={cn('flex items-center justify-center transition-transform duration-200', isOpen && 'rotate-180')}>
          <Icon icon={<ChevronIcon />} className='-rotate-90' />
        </div>
      </div>
      <div className={cn(!isOpen ? 'hidden' : 'block pt-3')}>
        <div className='mb-5'>
          <div className='flex justify-between gap-2'>
            <Text size='sm' color='secondary'>
              {t('corporateOptions.email')}
            </Text>
            <Text weight='medium' size='sm'>
              {profileStore.data?.emailAddress}
            </Text>
          </div>
        </div>
        <div className='mb-5'>
          <div className='flex justify-between gap-2'>
            <Text size='sm' color='secondary'>
              {t('corporateOptions.phoneNumber')}
            </Text>
            <Text weight='medium' size='sm'>
              {profileStore.data?.phoneAreaCode && FormatUtils.toPhoneFormat(profileStore.data.phoneAreaCode, profileStore.data?.phoneNumber)}
            </Text>
          </div>
        </div>
        {PermissionUtils.editProfileDetails() && (
          <Button className='mb-5' color='outlined' fullWidth onClick={() => setShowEditDetailsModal(true)}>
            {t('buttons.editDetails', { ns: 'common' })}
          </Button>
        )}
        <EditDetailsModal isOpen={showEditDetailsModal} onClose={() => setShowEditDetailsModal(false)} />
      </div>
    </div>
  );
};
